<div class="modules-container">
  <app-snow-effect></app-snow-effect>
  <!-- Header da página -->
  <header class="modules-header">
    <div class="header-left">
      <button class="logout-button" (click)="logout()">
        <mat-icon>arrow_back</mat-icon>
        <span>SAIR</span>
      </button>
    </div>
    <div class="header-center">
      <div class="sispac-logo">
        <img
          *ngIf="isChristmasMode"
          src="../../../assets/img/christmas/Gemini_Generated_Image_rcto20rcto20rcto-removebg-preview.png"
          alt="Logo Natal"
          class="logo-icon">
        <img
          *ngIf="!isChristmasMode"
          src="../../../assets/img/sispac-new/logo-sispac-new.png"
          alt="SISPAC Logo"
          class="logo-icon">
        <img
          *ngIf="!isChristmasMode"
          src="../../../assets/img/sispac-new/nome-sispac-new.png"
          alt="SISPAC"
          class="logo-text">
      </div>
    </div>
    <div class="header-right">
      <div class="user-profile" (click)="toggleProfileOverlay($event)">
        <div class="user-info">
          <span class="user-name">{{nomeServidor}}</span>
          <span class="user-orgao">{{lotacaoUsuario}}</span>
        </div>
        <div class="user-avatar">
          <mat-icon>account_box</mat-icon>
        </div>
      </div>
    </div>
  </header>

  <!-- Seção principal -->
  <main class="modules-main">
    <div class="modules-content">
      <!-- Área de boas-vindas -->
      <div class="welcome-section">
        <div class="welcome-text">
          <h2>Olá, {{nomeServidor}}</h2>
        </div>
        <div class="welcome-banner">
          <p style="font-size: 1.1rem;">Bem-vindo(a) ao <strong>Sistema de Controle de Procedimentos Administrativos Correcionais - SISPAC</strong></p>
        </div>
      </div>

      <!-- Título da seção de módulos -->
      <div class="modules-title">
        <h3>Você tem acesso aos seguintes módulos:</h3>
      </div>

      <!-- Grid de módulos -->
      <div class="modules-grid">
        <div class="module-card"
             *ngFor="let m of modulos"
             (click)="getPerfilUsuarioModulo(m)"
             [attr.data-module]="m.sigla">
          <div class="module-bg">
            <img [src]="getModuleBackgroundImage(m.sigla)"
                 [alt]="m.sigla + ' background'">
          </div>
          <div class="module-overlay">
            <div class="module-icon-wrapper">
              <img class="module-icon"
                   src="../../../assets/img/{{m.sigla.toLowerCase()}}.svg"
                   alt="{{m.sigla}}">
            </div>
            <div class="module-name">
              <h4>{{getModuloLabel(m.sigla)}}</h4>
            </div>
          </div>
        </div>

        <!-- Card para o Norma Chatbot -->
        <!-- <div class="module-card chatbot-card" routerLink="/chatbot">
          <div class="module-bg">
            <img src="../../../assets/img/chatbot_icon.png" alt="Chatbot background">
          </div>
          <div class="module-overlay chatbot-overlay">
            <div class="module-icon-wrapper">
              <img class="module-icon"
                   src="../../../assets/img/chatbot_icon.png"
                   alt="Chatbot icon">
            </div>
            <div class="module-name">
              <h4>Norma Chatbot</h4>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </main>

  <!-- Footer com informações da CGE -->
  <footer class="modules-footer">
    <div class="footer-content">
      <img
        *ngIf="isChristmasMode"
        src="../../../assets/img/sispac-new/colorida-com-escrita-verde.png"
        alt="Logo do Estado de Goiás"
        class="footer-logo">
      <img
        *ngIf="!isChristmasMode"
        src="../../../assets/img/sispac-new/colorida-com-escrita-verde.png"
        alt="Logo do Estado de Goiás"
        class="footer-logo">
      <div class="footer-info">
        <p>Controladoria-Geral do Estado de Goiás</p>
        <p>Desenvolvimento e Gestão</p>
      </div>
    </div>
  </footer>
</div>
